import React from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Typography from '@mui/material/Typography';
import BreadCrumbTooltip from 'shared/components/bread-crumb/bread-crumb-tooltip/bread-crumb-tooltip';

import styles from './bread-crumb.module.scss';

type Props = {
  showEllipsis: boolean;
  startIcon?: React.JSX.Element;
  children: React.JSX.Element | Array<React.JSX.Element>;
  allElementNames: string | Array<string>;
  amountOfOrganisationUnitsShown?: number;
};

const BreadCrumb = ({
  showEllipsis,
  startIcon,
  children,
  allElementNames,
  amountOfOrganisationUnitsShown = 2,
}: Readonly<Props>): React.JSX.Element => {
  const renderBreadCrumbs = (): React.JSX.Element[] => {
    let crumbs: Array<React.JSX.Element> = [];
    if (showEllipsis) {
      crumbs.push(
        <Typography variant="body2" key="ellipsis">
          ...
        </Typography>,
      );
    }
    if (Array.isArray(children)) {
      crumbs =
        showEllipsis && children.length > amountOfOrganisationUnitsShown
          ? crumbs.concat(children.slice(children.length - amountOfOrganisationUnitsShown))
          : crumbs.concat(children);
    } else {
      crumbs.push(children);
    }
    return crumbs;
  };

  return (
    <BreadCrumbTooltip allElementNames={allElementNames}>
      <div className={styles.container}>
        {startIcon && <div className={styles.startIconContainer}>{startIcon}</div>}
        {renderBreadCrumbs().map((child, index, { length }) => (
          <React.Fragment key={`bread_crumb_${child.key}`}>
            {child}
            {index + 1 < length && <ChevronRightIcon className={styles.chevronRightIcon} />}
          </React.Fragment>
        ))}
      </div>
    </BreadCrumbTooltip>
  );
};

export default BreadCrumb;
